import { renderDate, DocumentViewer, Spinner } from '../../../..';
import _ from 'lodash';
import React from 'react';
import { ILetterDetailProps } from './letter-detail.types';
import * as S from '../claim-timeline.styles';
import { formatDate } from '../../../../services/primitives/date-utils';


export const LetterDetail: React.FunctionComponent<ILetterDetailProps> = (
    props: ILetterDetailProps
): React.ReactElement => {
    const { letter, appType, documentUrl, loading = false } = props;

    const response = letter.response || {};
    const { to, expectedDeliveryDate, carrier, trackingEvents } = response;

    const formatAddress = (address?: typeof to): string | undefined => {
        if (!address) {
            return undefined;
        }
        return _.join(
            _.compact([
                address.name || address.company,
                address.addressLineOne,
                address.addressLineTwo,
                address.city && address.state && address.zip 
                    ? `${address.city}, ${address.state} ${address.zip}` 
                    : undefined,
                address.country,
            ]),
            '  \n', // Markdown line breaks with 2+ spaces
        );
    };

    const formattedAddress = formatAddress(to);

    return (
        <S.ExpandWrap key={letter.id}>
            {loading ? (
                <Spinner />
            ) : (
                <S.ExpandCol>
                    {/* App-Specific Fields Table */}
                    <S.ExpandTable expand={true}>
                        <S.ExpandTBody>
                            {appType === 'support' && (
                                <S.ExpandTR>
                                    <S.ExpandTH>ID</S.ExpandTH>
                                    <S.ExpandTD>{letter.id}</S.ExpandTD>
                                </S.ExpandTR>
                            )}
                            {appType === 'provider' && (
                                <>
                                    <S.ExpandTR>
                                        <S.ExpandTH>Carrier</S.ExpandTH>
                                        <S.ExpandTD>{carrier ? carrier : '-'}</S.ExpandTD>
                                    </S.ExpandTR>
                                    <S.ExpandTR>
                                        <S.ExpandTH>Expected Delivery Date</S.ExpandTH>
                                        <S.ExpandTD>{expectedDeliveryDate ? renderDate(expectedDeliveryDate) : '-'}</S.ExpandTD>
                                    </S.ExpandTR>
                                </>
                            )}
                            <S.ExpandTR>
                                <S.ExpandTH>To</S.ExpandTH>
                                <S.ExpandTD>
                                    <S.MarkdownBlock>{formattedAddress}</S.MarkdownBlock>
                                </S.ExpandTD>
                            </S.ExpandTR>
                        </S.ExpandTBody>
                    </S.ExpandTable>

                    {/* Tracking Events Section */}
                    {!!trackingEvents?.length && (
                        <S.ExpandTable expand={true} style={{ marginTop: '16px' }}>
                            <S.ExpandTBody>
                                <S.ExpandTR>
                                    <S.ExpandTH colSpan={2}>Tracking Events</S.ExpandTH>
                                </S.ExpandTR>
                                {_.reverse([...trackingEvents]).map((event, index) => (
                                    <S.ExpandTR key={event.time || index}>
                                        <S.ExpandTD>
                                            {event.time 
                                                ? formatDate(event.time, 'MMM dd, yyyy hh:mm a Z')
                                                : '--'}
                                        </S.ExpandTD>
                                        <S.ExpandTD>{event.name}</S.ExpandTD>
                                    </S.ExpandTR>
                                ))}
                            </S.ExpandTBody>
                        </S.ExpandTable>
                    )}

                    {/* Document Preview */}
                    {documentUrl && (
                        <div style={{ marginTop: '16px' }}>
                            <DocumentViewer url={documentUrl} />
                        </div>
                    )}
                </S.ExpandCol>
            )}
        </S.ExpandWrap>
    );
};
